import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from 'tradera-lang/translate';
import { useCountdown } from 'tradera-hooks/use-countdown';
import { formatStaticEndTime } from 'tradera-utils/format';
import { formatItemCardTimeLeft } from 'tradera-utils/format-time-left';

const EndTimeLabel = ({ className, endDate, isActive }) => {
    if (!endDate) return null;

    return isActive ? (
        <EndTimeLabelWithCountDown className={className} endDate={endDate} />
    ) : (
        <EndTimeLabelEnded className={className} />
    );
};

const EndTimeLabelEnded = ({ className }) => {
    const { t } = useTranslator();
    return <span className={className}>{t('vip_ended')}</span>;
};

const EndTimeLabelWithCountDown = ({ className, endDate }) => {
    const { t } = useTranslator();
    const {
        timeLeftText,
        isCountdownDone,
        isCountdownEnabled,
        isTimeLeftBelowWarningLimit
    } = useCountdown(endDate, formatItemCardTimeLeft);

    return (
        <span className={`item-card-animate-time ${className}`}>
            {isCountdownEnabled && isCountdownDone ? (
                <span className={`text-danger`}>{t('itemCard_ended')}</span>
            ) : (
                <span
                    className={`${
                        isTimeLeftBelowWarningLimit ? 'text-danger' : ''
                    }`}>
                    {timeLeftText || formatStaticEndTime(endDate, t)}
                </span>
            )}
        </span>
    );
};
EndTimeLabel.propTypes = {
    className: PropTypes.string,
    endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    isActive: PropTypes.bool
};
EndTimeLabel.defaultProps = {
    className: ''
};

export default EndTimeLabel;
